import { Pipe, PipeTransform } from '@angular/core';
import { DateConversionService } from '../services/date-conversion.service';

@Pipe({
  name: 'isoDateTime',
  standalone: true
})
export class IsoToFormattedDateTimePipe implements PipeTransform {

  constructor(private dateConversionService: DateConversionService) { }

  transform(isoTimestamp: string): string {
    return this.dateConversionService.isoToFormattedDateTime(isoTimestamp);
  }

}
